import { registerSprite } from "./registry";

function svg(w: number, h: number, body: string): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}">${body}</svg>`;
}

registerSprite("plume_ray", {
  width: 8, height: 8,
  svg: svg(8, 8, `<rect width="8" height="8" fill="#0a0604"/>`),
});

registerSprite("spark_ember", {
  width: 2, height: 2,
  svg: svg(2, 2, `<rect width="2" height="2" fill="#040404"/>`),
});

const CREW_GREEN = "#48c267";
const CREW_AMBER = "#e6a534";
const CREW_RED   = "#d33a3a";
function crewDotSvg(fill: string, gradId: string): string {
  return svg(16, 16, `
    <defs>
      <radialGradient id="${gradId}" cx="8" cy="8" r="8" gradientUnits="userSpaceOnUse">
        <stop offset="0"    stop-color="${fill}" stop-opacity="1"/>
        <stop offset="0.45" stop-color="${fill}" stop-opacity="0.85"/>
        <stop offset="1"    stop-color="${fill}" stop-opacity="0"/>
      </radialGradient>
    </defs>
    <rect width="16" height="16" fill="url(#${gradId})"/>
  `);
}
registerSprite("crew_dot_green", { width: 16, height: 16, svg: crewDotSvg(CREW_GREEN, "cdg") });
registerSprite("crew_dot_amber", { width: 16, height: 16, svg: crewDotSvg(CREW_AMBER, "cda") });
registerSprite("crew_dot_red",   { width: 16, height: 16, svg: crewDotSvg(CREW_RED,   "cdr") });

registerSprite("crew_dot_ring", {
  width: 12, height: 12,
  svg: svg(12, 12, `
    <circle cx="6" cy="6" r="5.4" fill="none" stroke="#ffffff" stroke-width="1" stroke-opacity="0.85"/>
  `),
});

// LOD dots: when an entity shrinks below a few screen pixels (or is far enough
// to be demoted), it collapses to one of these soft radial blobs instead of its
// full per-module silhouette. Same gradient recipe as the crew dots so they
// fade cleanly at the rim and read as "individual sprite dots" when zoomed out.
const LOD_SHIP = "#9fc6e8";
const LOD_ROCK = "#8a7e6f";
const LOD_ITEM = "#d8a94a";
function lodDotSvg(fill: string, gradId: string): string {
  return svg(16, 16, `
    <defs>
      <radialGradient id="${gradId}" cx="8" cy="8" r="8" gradientUnits="userSpaceOnUse">
        <stop offset="0"    stop-color="${fill}" stop-opacity="1"/>
        <stop offset="0.5"  stop-color="${fill}" stop-opacity="0.7"/>
        <stop offset="1"    stop-color="${fill}" stop-opacity="0"/>
      </radialGradient>
    </defs>
    <rect width="16" height="16" fill="url(#${gradId})"/>
  `);
}
registerSprite("lod_dot_ship", { width: 16, height: 16, svg: lodDotSvg(LOD_SHIP, "lds") });
registerSprite("lod_dot_rock", { width: 16, height: 16, svg: lodDotSvg(LOD_ROCK, "ldr") });
registerSprite("lod_dot_item", { width: 16, height: 16, svg: lodDotSvg(LOD_ITEM, "ldi") });
